module.exports = __webpack_public_path__ + "img/hakhak_app_2.e5404907.png";